// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3S1Kz","inner":"Footer_inner__9NGJw","nextIcon":"Footer_nextIcon__u8vVL","innerLeft":"Footer_innerLeft__1l_gj"};